// extracted by mini-css-extract-plugin
module.exports = {"vacancyPriorityWrapper":"vacancyPriority_vacancyPriorityWrapper__1FvOO","priority":"vacancyPriority_priority__1vjlQ"};